import {AbstractControl, FormArray, FormControl, FormGroup} from '@angular/forms';

export const validateAllFormFields = (formGroup: FormGroup) => {
  Object.keys(formGroup.controls).forEach(field => {
    const control = formGroup.get(field);
    if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty({ onlySelf: true });
    } else if (control instanceof FormGroup) {
      validateAllFormFields(control);
    } else if (control instanceof FormArray) {
      for (let i = 0; i < control.controls.length; i++) {
        validateField(control.at(i));
      }
    }
  });
};

export const validateField = (formControl: AbstractControl) => {
  formControl.markAsTouched({ onlySelf: true });
  formControl.markAsDirty({ onlySelf: true });
};
